import React from 'react';

import Button from '@amzn/meridian/button';
import { createDataCyForJob, type TableDataRow } from 'src/utils/jmrUtils';

interface ModifyBtnProps {
  row: TableDataRow;
  onClickModify: (row: TableDataRow, shiftId?: string) => void;
  canBeModified: boolean;
  hasBeenModified: boolean;
  shiftId?: string;
  /** A shift's button is labelled with its shift code to distinguish it from the job's other shifts */
  shiftCode?: string;
}

const ModifyBtn = ({ row, hasBeenModified, canBeModified, onClickModify, shiftId, shiftCode }: ModifyBtnProps) => {
  const label = hasBeenModified ? 'Edit' : 'Modify';
  const name = shiftCode ? `${row.name} ${shiftCode}` : row.name;
  const dataCy = shiftCode ? `${createDataCyForJob(row.name)}-${shiftCode}` : createDataCyForJob(row.name);

  return canBeModified ? (
    <Button
      size="small"
      type="tertiary"
      minWidth="80%"
      data-cy={`${dataCy}-modify`}
      onClick={() => onClickModify(row, shiftId)}
      aria-label={`${label} ${name}`}
    >
      {label}
    </Button>
  ) : null;
};

export default ModifyBtn;
